import axios from 'axios';
import { supabase } from '../auth/supabaseClient';
import { API_BASE_URL } from '../constants';

const cancelSubscription = async (subscriptionId, clientId, accessToken) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/cancel-subscription`, {
            subscription_id: subscriptionId,
            client_id: clientId,
        }, 
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`
          }
        });
        console.log('Subscription canceled successfully:', response.data);
    } catch (error) {
        console.error('Error canceling subscription:', error);
    }
};

const fetchStripeLink = async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        console.log("Session found:", session);
        const clientId = session.user.id;
        console.log("Client ID:", clientId);
        const accessToken = session.access_token;
  
        // Make the axios GET request with the client ID
        const response = await axios.get(`${API_BASE_URL}/get-stripe-link`, {
          params: { client_id: clientId },
          headers: {
            'Authorization': `Bearer ${accessToken}`
          }
        });
        // Return the Stripe link
        return response.data.url;
      } else {
        console.log("No session found");
        return null;
      }
    } catch (error) {
      console.error("Error fetching the Stripe payment link:", error);
      return null;
    }
  };

export { cancelSubscription, fetchStripeLink };
